<template>
  <div class="amendsite">
    <!--头部-->
    <!--<van-nav-bar title="修改收货地址" fixed left-arrow @click-left="goBack"></van-nav-bar>-->
    <div style="padding-top: 0" class="van-content">
      <van-cell-group style="margin-bottom: 0">
        <van-field v-model="name" placeholder="请输入收货人" label="收货人"/>
        <van-field v-model="mobile" placeholder="请输入手机号码" label="手机号码"/>
        <van-field v-model="sitedDatasName" placeholder="选择地址" readonly label="省市区" @click="cityPickershow"/>
        <!--<van-field v-model="setess" placeholder="" label="详细地址："/>-->
        <div>
          <div rows="1" maxlength="200" placeholder="如街道、楼层、门牌号等" class="van-cell van-hairline van-field">
            <div><span>详细地址</span>
            </div>
            <div class="van-cell__value" style="margin-left:30px">
              <div class="van-field__body">
                <textarea rows="2" v-model="setess" maxlength="200" placeholder="如街道、楼层、门牌号等" class="van-field__control"></textarea>
              </div>
            </div>
          </div>
        </div>
      </van-cell-group>
      <van-cell-group>
        <van-cell title="设为默认">
          <van-checkbox  v-model="checked"/>
        </van-cell>
      </van-cell-group>
      <van-button size="large" class="addSiteBtn theme-bd theme-bg" @click="sendDatas">保存地址</van-button>
    </div>
    <!--地址选择弹框-->
    <City-Picker ref="CityPicker" v-on:listenSitedata="geSitedatas"></City-Picker>
  </div>
</template>

<script>
  import CityPicker from '@/pages/user/mysite/cityPicker'
  export default {
    name: "addsite",
    components: {
      CityPicker
    },
    data () {
      return {
        siteId:this.$route.query.id,
        sitedDatas:'',
        sitedDatasName:'',
        checked:false,//设为默认
        name:'',//收货人
        mobile:'',//手机号
        site:'',//省市区
        setess:'',//详细地址
        province:'',
        city:'',
        town:'',
        county:''
      }
    },
    methods:{
      cityPickershow:function () {
        this.$refs.CityPicker.cityPickershow()
      },
      geSitedatas:function (datas) {
        this.sitedDatasName = ''
        this.sitedDatas = datas
        if(datas[0].id != undefined){
          this.sitedDatasName += datas[0].name
          this.province = datas[0].id
        }
        if(datas[1].id != undefined){
          this.sitedDatasName += "-"+datas[1].name
          this.city = datas[1].id
        }
        if(datas[2].id != undefined){
          this.sitedDatasName += "-"+datas[2].name
          this.town = datas[2].id
        }
        if(datas[3].id != undefined){
          this.sitedDatasName += "-"+datas[3].name
          this.county = datas[3].id
        }
      },
      goBack: function () {
        history.back(-1);
      },
      getDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Address/preview', {token:isUser,id:this.siteId}, res => {
          if(res.data.errCode == '0000'){
            this.name = res.data.data.name
            this.mobile = res.data.data.mobile
            this.sitedDatasName = res.data.data.addressInfo
            this.setess = res.data.data.address
            this.province = res.data.data.province
            this.city = res.data.data.city
            this.town = res.data.data.town
            this.county = res.data.data.county
            res.data.data.moren == 1 ? this.checked = true : this.checked = false
          }else{
            this.$toast(res.data.desc)
          }
        })
      },
      sendDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        var _this = this
        var moren = 0
        if(this.checked == true){
          moren = 1
        }else{
          moren = 0
        }
        this.$api.post('WebApi/Member/Address/setAddrItem', {token:isUser,id:this.siteId,moren:moren,name:this.name,mobile:this.mobile,address:this.setess,province:this.province,city:this.city,town:this.town,county:this.county}, res => {
          if(res.data.errCode == '0000'){
            this.goBack()
          }else{
            this.$toast(res.data.desc)
          }
        })
      }
    },
    mounted () {
      this.getDatas()
    },
  }
</script>

<style lang="less" scoped>
  .amendsite{
    .van-cell-group{
      background-color: #fff;
    }
    .addSiteBtn{
      border-right: 0;
      border-radius: 6px;
      margin-top: 40px;
      width: 90%;
      margin-left: 5%;
      padding: 0 15px;
      box-sizing: border-box;
      button{
        border-radius: 6px;
        border: none;
        width: 100%;
        float: left;
      }
    }

    van-checkbox__icon--checked{
      van-icon{
        border-color: #D7000A!important;
        background-color: #D7000A!important;
      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/pages/user/mysite/amendsite.vue